import React from 'react';
import { Field } from 'formik';

import Description from '@/components/forms/description';

import styles from './Checkbox.module.css';

function Checkbox({
    className = '',
    small = false,
    description = '',
    error = false,
    errorText = '',
    label = null,
    labelComponent = null,
    name,
    tipId = '',
    tipContent = '',
    disabled = false,
    onChange = (_opt) => null,
}) {
    const baseClass = `${disabled ? styles.disabled : styles.checkbox} ${className}`;
    const sizeClass = small && styles.small;
    const errClass = error && styles.error;
    const finalClass = `${baseClass} ${sizeClass} ${errClass}`;

    return (
        <div>
            <div className="w-full leading-6">
                <Field
                    name={name}
                >
                    {({ field, form: { handleChange } }) => (
                        <input
                            id={name}
                            type="checkbox"
                            name={name}
                            data-tooltip-id={tipId}
                            data-tooltip-content={tipContent}
                            className={finalClass}
                            disabled={disabled}
                            {...field}
                            checked={field.value}
                            onChange={(e) => {
                                if (!disabled) {
                                    handleChange(name)(e);
                                    onChange(e.target.checked);
                                }
                            }}
                        />
                    )}
                </Field>

                {label && (
                    <label
                        className={`${styles.label} ${disabled && styles.labelDisabled} ${error && styles.labelError}`}
                        htmlFor={name}
                    >
                        {label}
                    </label>
                )}
                {!label && labelComponent && (
                    <label
                        className={`${styles.labelComponent} ${error && styles.labelError}`}
                        htmlFor={name}
                    >
                        {labelComponent}
                    </label>
                )}
            </div>
            <div className="leading-3">
                <Description
                    externalStyles="not-italic pl-0 sm:pl-[28px]"
                    description={description}
                    disabled={disabled}
                />
            </div>
            {error && errorText.length > 0 && (
                <div className={styles.errorText}>
                    {errorText}
                </div>
            )}
        </div>
    );
}

export default Checkbox;
